import { buildingThresholdsApi } from './buildingsApi';
import { locationApi } from './locationApi';
import { thresholdsApi } from './thresholdsApi';
import { virtualDevicesApi, virtualDevicesMutationApi } from './virtualDevicesApi';

export * from './virtualDevicesApi';
export * from './locationApi';
export * from './buildingsApi';
export * from './thresholdsApi';

export const businessApiSlices = [
    virtualDevicesApi,
    locationApi,
    virtualDevicesMutationApi,
    buildingThresholdsApi,
    thresholdsApi,
];
